import type { UseQueryOptions } from '@tanstack/react-query';

import { iamListUserOrgs } from '@crossnokaye/typescript-sdk/funcs/iamListUserOrgs';
import { Organization } from '@crossnokaye/typescript-sdk/models/components';
import { SDKError } from '@crossnokaye/typescript-sdk/models/errors';
import {
  ListUserOrgsQueryParamView,
  ListUserOrgsRequest,
  ListUserOrgsResponse,
} from '@crossnokaye/typescript-sdk/models/operations';

import { AtlasClientFunction } from '@/client/types';

const transformListUserOrgsResponse = (data: ListUserOrgsResponse): Organization[] => {
  return data.organizationCollection ?? [];
};

export interface ListUserOrgsQueryProps {
  userId: string | undefined;
  view?: ListUserOrgsQueryParamView;
  client: AtlasClientFunction;
  transform?: (data: ListUserOrgsResponse) => Organization[] | undefined | any;
}

export const listUserOrgsQuery = ({
  userId,
  view = ListUserOrgsQueryParamView.Default,
  client,
  transform = transformListUserOrgsResponse,
}: ListUserOrgsQueryProps): UseQueryOptions<
  ListUserOrgsResponse,
  SDKError,
  Organization[] | undefined | any
> => {
  return {
    enabled: !!userId,
    queryKey: [userId, 'listUserOrgs', view],
    queryFn: () =>
      client<ListUserOrgsRequest, ListUserOrgsResponse>({
        atlasFunc: iamListUserOrgs,
        request: { userId: userId!, view },
      }),
    staleTime: Infinity,
    select: transform,
  };
};
